// ADDED [06/07/2026]: New generic book-an-appointment page (/book-appointment).
// No referral partner, not a new-build page. Modeled on ContactPage.jsx but
// deliberately leaner - only Hero2 + the appointment form, none of the extra
// marketing blocks (BlockSteps/BlockAbout/BlockBudget/BlockAwards) or the
// Taylor Wimpey modal effect, which don't apply to this route.
import { useState } from "react";
import FormContact from "../components/FormContact";
import Hero2 from "../components/Hero2";
import Title from "../components/Title";

function BookAppointmentPage(props) {
  const [formSubmitted, setFormSubmitted] = useState(false);

  return (
    <>
      <Hero2 />

      {/* ADDED [06/07/2026]: Curved divider below the hero. BlockSteps.jsx normally
          supplies this (it's the first thing BlockSteps renders), but this page
          deliberately excludes BlockSteps, so the curve was missing beneath the
          hero. Copied the same SVG markup used at the top of BlockSteps.jsx. */}
      <div className="cur mt-12 h-12 md:mt-16 md:h-16">
        <svg
          viewBox="0 0 1280 192"
          preserveAspectRatio="none"
          className="h-full w-full fill-current text-gray-100"
        >
          <path
            d="M-216,1135.969s320,192,640,192,640-192,640-192Z"
            transform="translate(1064 1327.968) rotate(180)"
          />
        </svg>
      </div>

      <div id="contact" className="scroll-mt-16">
        <div className="bg-gray-100 px-4 py-16 md:px-6 lg:px-8">
          <div className="mx-auto w-full max-w-3xl">
            <div className="mb-16">
              <Title
                title={!formSubmitted ? "Book an appointment" : "Thank you!"}
              />
            </div>

            {!formSubmitted && (
              <FormContact setFormSubmitted={setFormSubmitted} />
            )}
            {formSubmitted && (
              <div className="text-center text-black">
                <p className="text-lg ">
                  <span className="font-bold">Your enquiry has been sent!</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default BookAppointmentPage;
